export const createQueryString = (queryParams: Record<string, string | number | string[]>) => {
  return Object.entries(queryParams)
    .filter(([, value]) => Boolean(value))
    .map(entry => entry.join('='))
    .join('&');
};
